import { gql } from "@apollo/client"
import { MaybePick } from "~/app/utils/typeUtils"
import { Company, DirectDebitConstraint, InvoicingCompanySettings } from "@oysterhr/schema"

export const DirectDebitForDepositInvoiceFragment = gql`
  fragment DirectDebitForDepositInvoiceFragment on Company {
    directDebitConstraint {
      blocked
    }
    directDebitAuthorized
    directDebitAvailable
    directDebitEnforced
    invoicingSettings {
      depositBeforeLiability
    }
  }
`

export type DirectDebitForDepositInvoiceFragmentType = Pick<
  Company,
  "directDebitAuthorized" | "directDebitAvailable" | "directDebitEnforced"
> & {
  directDebitConstraint?: MaybePick<DirectDebitConstraint, "blocked">
  invoicingSettings?: MaybePick<InvoicingCompanySettings, "depositBeforeLiability">
}
